import { isCheckPermission } from "../base/localuser";
import { getLocalParticipant, getLocalParticipantId, PARTICIPANT_JOINED, PARTICIPANT_LEFT, PERMISSION } from "../base/participants";
import { MiddlewareRegistry } from "../base/redux";
import { setVideoLayoutProperty } from "./actions";
import { SET_VIDEO_LAYOUT_MODE } from "./actionType";
import { documentLayoutList, layoutList, shareLayoutList, videoLayoutMode } from "./constants";
import { getCurrentMode, updateRemoteParticipants, updateRemoteParticipantsOnLeave } from "./functions";
import "./subscriber";

MiddlewareRegistry.register(store => next => action => {
    const state = store.getState();

    switch (action.type) {
        case SET_VIDEO_LAYOUT_MODE:
            const { prevLayoutMode } = state['features/video-layout-mode'] || videoLayoutMode.default;
            const currentMode = getCurrentMode(state);  
            const nextMode = action.mode;
            let mode = nextMode;
            if (action.isRemote) {
                if (documentLayoutList.indexOf(currentMode) !== -1 && documentLayoutList.indexOf(nextMode) === -1) {
                    store.dispatch(setVideoLayoutProperty({ prevDocumentMode: currentMode }));
                } else if (layoutList.indexOf(currentMode) !== -1 && layoutList.indexOf(nextMode) === -1) {
                    store.dispatch(setVideoLayoutProperty({ prevLayoutMode: currentMode }));
                }

                return next({
                    ...action,
                    mode: nextMode
                });
            }

            if (currentMode === nextMode) {
                return;            
            } else {
                // if ((layoutList.indexOf(nextMode) !== -1 && shareLayoutList.indexOf(currentMode) !== -1) || 
                //     (shareLayoutList.indexOf(nextMode) !== -1 && shareLayoutList.indexOf(currentMode) !== -1)
                // ) mode = prevLayoutMode;
                
                if (videoLayoutMode.screen === currentMode && videoLayoutMode.screen !== mode) {
                    const sharingVideo = state['features/screen-share'].sharingVideo;

                    const member_uuid = getLocalParticipant(state)?.member_uuid;
                    stopScreenShare(member_uuid, sharingVideo);
                }
            }

            if (documentLayoutList.indexOf(currentMode) !== -1 && documentLayoutList.indexOf(mode) === -1) {
                store.dispatch(setVideoLayoutProperty({ prevDocumentMode: currentMode }));
            } else if (layoutList.indexOf(currentMode) !== -1 && layoutList.indexOf(mode) === -1) {
                store.dispatch(setVideoLayoutProperty({ prevLayoutMode: currentMode }));
            }

            if (!mode) mode = videoLayoutMode.default;
            
            if (isCheckPermission(store.getState(), PERMISSION.SHARE)) {
                const viewVisible = {
                    [videoLayoutMode.screen]: mode === videoLayoutMode.screen ? true : false,
                    [videoLayoutMode.vod]: mode === videoLayoutMode.vod ? true : false,
                    [videoLayoutMode.white]: mode === videoLayoutMode.white ? true : false,
                    [videoLayoutMode.document]: mode === videoLayoutMode.document ? true : false,
                    [videoLayoutMode.note]: mode === videoLayoutMode.note ? true : false
                };
                
                APP.mateManagement.setLayoutMode(mode, viewVisible);
            }
            return next({
                ...action,
                mode
            });

        case PARTICIPANT_JOINED: {
            updateRemoteParticipants(store);
            break;
        }
        case PARTICIPANT_LEFT: {
            updateRemoteParticipantsOnLeave(store, action.participant.user_uuid);
            break;
        }
    }

    return next(action);
});

function stopScreenShare(member_uuid, sharingVideo) {    
    if (sharingVideo.member_uuid === member_uuid) {
        APP.mateManagement.toggleScreenShare(false);
    } else {
        APP.mateManagement.requestStopScreenShare();
    }
}